import { Box, Stack } from '@mui/system'
import { useMemo } from 'react'

import HomeLogo from 'assets/home-logo'
import LactationLogo from 'assets/LactationLogo'

import AnalyticsIcon from 'assets/AnalyticsIcon'
import CattlesLogo from 'assets/CattlesLogo'
import FeedTableIcon from 'assets/FeedTableIcon'
import GroupsIconLogo from 'assets/GroupsIconLogo'
import HealthIcon from 'assets/HealthIcon'

import MilkCup from 'assets/MilkCup'
import { useAppSelector } from 'store/hooks'
import { showMilkYieldUi } from 'utils/companyMilkFeatures'
import { Scrollbar } from 'ui/scrollbar/Scrollbar'
import { MainSidebarLink } from 'ui/sidebar/shared/MainSidebarLink/MainSidebarLink'

const SidebarMainMenu = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { userData } = useAppSelector(state => state.userReducer)
	const canShowMilkYield = showMilkYieldUi(userData?.company?.id)
	const sidebarMenuSections = useMemo(
		() =>
			[
				permissions?.can_view_foodtable_main && {
					key: '/feed',
					value: 'Ферма',
					icon: <HomeLogo width='18px' height='18px' />,
				},
				(permissions?.license_fatness ||
					permissions?.license_identification ||
					permissions?.license_limpness) && {
					key: '/cattles',
					value: 'Поголовье',
					icon: <CattlesLogo width='18px' height='18px' />,
				},
				permissions?.can_view_cattle_groups && {
					key: '/feed/groups',
					value: 'Группы',
					icon: <GroupsIconLogo width='18px' height='18px' />,
				},
				permissions?.license_food_table
					? {
							key: 'food_table',
							value: 'Кормовой стол',
							icon: <FeedTableIcon width='18px' height='18px' />,
							disablePointer: true,
							children: [
								permissions?.can_view_rations && {
									key: '/feed/ration',
									value: 'Рационы',
								},
								permissions?.can_view_feedplans && {
									key: '/feed/plan',
									value: 'План кормления',
								},
							].filter(Boolean),
						}
					: null,
				(() => {
					const hasFatness = permissions?.license_fatness
					const hasLameness = permissions?.license_limpness
					const icon = <HealthIcon width='18px' height='18px' />

					if (hasFatness && hasLameness) {
						return {
							key: 'health',
							value: 'Здоровье',
							icon,
							disablePointer: true,
							children: [
								{ key: '/cattles/fatness', value: 'Упитанность' },
								{ key: '/cattles/lameness', value: 'Хромота' },
							],
						}
					}

					if (hasFatness) {
						return {
							key: '/cattles/fatness',
							value: 'Упитанность',
							icon,
						}
					}

					if (hasLameness) {
						return {
							key: '/cattles/lameness',
							value: 'Хромота',
							icon,
						}
					}

					return null
				})(),
				permissions?.license_milking_process_check && {
					key: '/milking-process',
					value: 'Рутина доения',
					icon: <LactationLogo width='16px' height='16px' />,
					children: [
						{
							key: '/milking-process/shifts',
							value: 'Смены доения',
						},
					],
				},
				permissions?.license_identification &&
					canShowMilkYield && {
						key: '/feed/milk-yield',
						value: 'Надой',
						icon: <MilkCup width='18px' height='18px' />,
					},
				permissions?.can_view_analytics &&
					permissions?.license_food_table && {
						key: '/feed/analytics',
						value: 'Аналитика',
						icon: <AnalyticsIcon width='18px' height='18px' />,
					},
			].filter(Boolean),
		[canShowMilkYield, permissions],
	)

	return (
		<Box sx={{ mt: '10%', flex: 1, minHeight: 0, display: 'flex' }}>
			<Scrollbar sx={{ flex: 1, minHeight: 0 }}>
				<Stack direction='column'>
					{sidebarMenuSections.map(e => (
						<MainSidebarLink
							key={e.key}
							to={e.key}
							icon={e.icon}
							textMenu={e.value}
							subMenuItems={e.children}
						/>
					))}
				</Stack>
			</Scrollbar>
		</Box>
	)
}

export default SidebarMainMenu
